<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title {{ config.title }}
        p {{ config.content }}
        br
        .columns.is-vcentered
          .column.is-offset-2.is-4
            .field
              label.label {{ config.question }}
              .control.has-icons-left.has-icons-right
                input.input.is-black(
                  type='text', 
                  placeholder='00.00',
                  v-model="valor"
                )
          .column.is-4
            ToggleButton(
              v-model="toogle" 
              :labels="{checked: 'Largo', unchecked: 'Corto'}"
              :color="{checked: '#53565A', unchecked: '#C8102E'}"
              :width="configButton.width"
              :height="configButton.height"
              :font-size="configButton.fontSize"
              )
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(@click="cerrarModal")
                    | {{ config.textCancel }}
                p.control
                  a.button.is-black.is-rounded(@click="aceptar")
                    | {{ config.textOk }}
</template>

<script>
  import { ToggleButton } from 'vue-js-toggle-button'

  export default {
    name: 'ModalSello',
    components: { ToggleButton },
    props: {
      config: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        valor: 0,
        toogle: true,
        configButton: {
          width: 75,
          height: 30,
          fontSize: 14,
        }
      }
    },
    methods: {
      cerrarModal () {
        const obj = {
          save: false,
          valor: 0.0,
          tipo: null,
        }
        this.valor = 0.0
        this.$emit('modalEvent', obj)
      },
      aceptar () {
        const obj = {
          save: true,
          valor: this.valor,
          tipo: this.toogle ? 1 : 0
        }
        this.valor = 0.0
        this.$emit('modalEvent', obj)
      },
      
      updateSello (val) {
        this.toogle = val
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/componentes/ModalSello.vue